// extracted by mini-css-extract-plugin
module.exports = {"header":"custom-drawer_header__2n18P","close_button":"custom-drawer_close_button__36lEL"};